import { Checkbox, Modal, Row, Col, Button, Space } from "antd";
import commonCssStyle from "../../UI/CommonCss.module.css";
import { useState, useEffect } from "react";

const ColumnSelectorModal = ({
  isOpen,
  onClose,
  onApply,
  availableColumns,
  loading,
}) => {
  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    if (isOpen && availableColumns && availableColumns.length > 0) {
      // By default, select all columns
      setSelectedColumns(availableColumns.map((col) => col.key));
    }
  }, [isOpen, availableColumns]);

  const handleColumnToggle = (columnKey) => {
    setSelectedColumns((prev) =>
      prev.includes(columnKey)
        ? prev.filter((key) => key !== columnKey)
        : [...prev, columnKey]
    );
  };

  const handleSelectAll = () => {
    if (selectedColumns.length === availableColumns.length) {
      setSelectedColumns([]);
    } else {
      setSelectedColumns(availableColumns.map((col) => col.key));
    }
  };

  const handleApply = () => {
    onApply(selectedColumns);
    onClose();
  };

  return (
    <Modal
      title={
        <p className={`${commonCssStyle.marginBottomRemove} ${commonCssStyle.popUpHeadingText}`}>
          Select Columns to Export
        </p>
      }
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="selectAll"
          type="default"
          onClick={handleSelectAll}
          className={commonCssStyle.ButtonForNormalSecondary}
        >
          {selectedColumns.length === availableColumns?.length
            ? "Deselect All"
            : "Select All"}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleApply}
          loading={loading}
          disabled={selectedColumns.length === 0}
          className={commonCssStyle.ButtonForNormalPrimary}
        >
          Export
        </Button>,
      ]}
      width={600}
      centered
    >
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Row gutter={[16, 16]}>
          {availableColumns &&
            availableColumns.map((column) => (
              <Col key={column.key} xs={24} sm={12}>
                <Checkbox
                  checked={selectedColumns.includes(column.key)}
                  onChange={() => handleColumnToggle(column.key)}
                >
                  <span style={{ color: "var(--body-text-color)" }}>
                    {column.label}
                  </span>
                </Checkbox>
              </Col>
            ))}
        </Row>
      </div>
    </Modal>
  );
};

export default ColumnSelectorModal;
